import {on} from "@/others/common/eventDelegation";
import {toggleImageVisibility} from "@/front/js/components/images/toggleImageVisibility";

on("body", "click", ".variants-wrap .color", event => {
	const targetEl = event.target.closest(".color");
	const openVariantId = targetEl.dataset.variant;
	const productItemEl = targetEl.closest(".product-item");
	const imgsEl = productItemEl.querySelectorAll(".product-variant-image");
	const currentVariantImageEl = productItemEl.querySelector("[data-variant='" + openVariantId +"']");
	const variantsWrapEl = targetEl.closest(".variants-wrap");
	const allVariantsInWrapEls = variantsWrapEl.querySelectorAll(".color");
	const allVariantsWithCartEls = productItemEl.querySelectorAll(".variant-with-cart");
	const activeVariantWithCartEl = productItemEl.querySelector(`div[data-cartVariant='${targetEl.dataset.variant}']`);
	const variantWarehouseStatusEls = productItemEl.querySelectorAll(".variant-warehouse-status");
	const activeWarehouseStatusEl = productItemEl.querySelector(`.variant-warehouse-status[data-variant='${targetEl.dataset.variant}']`);

	toggleImageVisibility(imgsEl, currentVariantImageEl);

	allVariantsInWrapEls.forEach(el => {
		el.classList.remove("active");
	});

	allVariantsWithCartEls.forEach(el => {
		el.classList.remove("active");
	});

	variantWarehouseStatusEls.forEach(el => {
		el.classList.remove("active");
	});

	targetEl.classList.toggle("active");
	activeVariantWithCartEl.classList.toggle("active");
	activeWarehouseStatusEl.classList.toggle("active");
});
